



































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import type { ProjectUser } from '@/models/projectUser';
import type { XProcess } from '@/models/xprocess';
import type { Company } from '@/models/company';

@Component({
    name: 'XToDosFilters',
    components: {},
})
export default class XToDosFilters extends Vue {
    private selectedResponsibleUsers: ProjectUser[] = [];
    private selectedXProcesses: XProcess[] = [];

    @Getter('project/selectedProject') private selectedProject: Project;
    @Prop() private isDesktop: boolean;
    @Prop() private errors: string[];

    @Getter('account/company') private company: Company;
    @Getter('account/companyProcessName') private companyProcessName: string;
    @Getter('utils/currentLocale') private currentLocale: string;

    @Watch('selectedProject')
    private onSelectedProjectChange() {
        this.selectedResponsibleUsers = this.allProjectUsers;
        this.$emit('update:selected-responsible-users', this.selectedResponsibleUsers);

        if (this.selectedProject.xprocesses.length > 0) {
            this.selectedXProcesses = this.selectedProject.xprocesses;
            this.$emit('update:selected-x-processes', this.selectedXProcesses);
        }
    }

    private checkError(errorKey: string) {
        return this.errors.includes(errorKey);
    }

    private fullname({ firstname, lastname }) {
        return `${firstname} ${lastname}`;
    }

    private get allProjectUsers() {
        const projectUsers: ProjectUser[] = [];
        this.selectedProject.users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: false,
            };
            projectUsers.push(temp);
        });
        this.selectedProject.external_users.forEach((user, index) => {
            const temp: ProjectUser = {
                unique_identifier: Math.floor(Math.random() * 100000 + 1),
                firstname: user.firstname,
                lastname: user.lastname,
                email: user.email,
                user_id: user.id,
                isExternalUser: true,
            };
            projectUsers.push(temp);
        });

        return projectUsers;
    }
}
